import { ActionMenu, ConfirmationDialog } from '@ijoin/components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { camelCase } from 'lodash';
import { useToggle } from 'usehooks-ts';

type AdvisoryOrganization = {
  advisoryOrganizationId: string;
  billingRecordKeepingOrganizationName?: string;
  city?: string;
  name: string;
  state?: string;
};

export const AdvisoryOrgActionsCell = (props: {
  onDeleted: () => void;
  org: AdvisoryOrganization;
}) => {
  const [isDeleteOpen, toggleDeleteOpen] = useToggle();

  return (
    <>
      <ActionMenu
        actions={[{ content: 'Delete', onSelect: toggleDeleteOpen }]}
        trigger={
          <IconButton
            data-component='actionsMenu'
            data-testid={`actions-${camelCase(props.org.name)}`}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      <ConfirmationDialog
        confirmationText='DELETE'
        confirmColor='error'
        confirmText='Delete'
        data-testid={`delete-${camelCase(props.org.name)}`}
        isOpen={isDeleteOpen}
        message={`Are you sure you want to delete "${props.org.name}"? This action cannot be undone.`}
        onCancel={toggleDeleteOpen}
        onConfirm={() => {
          toggleDeleteOpen();
          props.onDeleted();
        }}
        title='Delete Advisory Organization'
      />
    </>
  );
};
